import { createCustomRouter, RouteConfig } from './custom-router';

const routes: RouteConfig[] = [

  {
    path: '/',
    // redirect: '/viewer'
    name: 'ModelList',
    component: () => import('../pages/ModelList.vue'),
    meta: { 
      title: 'Web Wide World',
      description: '探索高质量3D Gaussian Splatting重建场景，体验沉浸式虚拟世界。By Nobody, For Everyone - 平凡人共创普惠世界。',
      keywords: '3D Gaussian Splatting, 3DGS, 场景列表, 3D查看器'
    },
  },
  {
    path: '/v2',
    // redirect: '/viewer'
    name: 'ModelListV2',
    component: () => import('../pages/ModelListV2.vue'),
    meta: { 
      title: 'Web Wide World V2',
      description: 'Web Wide World V2版本场景列表。支持多种3D Gaussian Splatting场景，可控制虚拟角色在场景中自由探索。',
      keywords: '3DGS, 场景列表, 虚拟角色, 3D场景探索'
    },
  },
  {
    path: '/model',
    name: 'ModelDetail',
    component: () => import('../pages/ModelDetail.vue'),
    meta: {
      title: '场景详情 - Web Wide World',
      description: '查看3D场景的详细信息和预览。'
    },
    props: true,
  },
  {
    path: '/simple-viewer',
    name: 'ChunkedLoading',
    component: () => import('../pages/ChunkedLoading.vue'),
    meta: {
      title: '简易查看器 - Web Wide World',
      description: '轻量级3D场景查看器，支持分块加载大型场景。'
    },
    props: true,
  },
  {
    path: '/viewer',
    name: 'Viewer',
    component: () => import('../pages/Metaverse.vue'),
    meta: {
      title: 'Web Wide World',
      description: '沉浸式元宇宙体验，控制虚拟角色在3D Gaussian Splatting场景中自由行走探索。',
      keywords: '元宇宙, 虚拟角色, 3D探索, 沉浸式体验'
    },
    props: true,
  },
  {
    path: '/spark',
    name: 'spark',
    component: () => import('../pages/Spark.vue'),
    meta: {
      title: 'Spark 查看器 - Web Wide World',
      description: '基于 Spark 引擎的高性能3D Gaussian Splatting渲染器。'
    },
    props: true,
  },
  {
    path: '/viewer2',
    name: 'viewer2',
    component: () => import('../pages/scene-viewer/SceneViewer.vue'),
    meta: {
      title: 'Web Wide World',
      description: '新一代3D场景查看器，支持高质量Gaussian Splatting渲染和物理交互。',
      keywords: '场景查看器, 3DGS渲染, 物理引擎'
    },
    props: true,
  },
  {
    path: '/debug-viewer',
    name: 'debugViewer',
    component: () => import('../pages/scene-viewer/DebugSceneViewer.vue'),
    meta: { 
      title: 'Debug Scene Viewer',
      description: '调试用场景查看器。'
    },
    props: true,
  },
  {
    path: '/metaverse-interaction',
    name: 'MetaverseInteraction',
    component: () => import('../pages/Metaverse.vue'),
    meta: {
      title: '元宇宙交互 - Web Wide World',
      description: '元宇宙交互体验，在虚拟世界中与3D场景互动。'
    },
    props: true,
  },
  {
    path: '/test-gp/spark',
    name: 'TestGPSpark',
    component: () => import('../pages/test-gp/Spark.vue'),
    meta: { title: 'Spark 测试 - Web Wide World' },
    props: true,
  },
  {
    path: '/test-gp/mkkellogg',
    name: 'TestMkkellogg',
    component: () => import('../pages/test-gp/Mkkellogg.vue'),
    meta: { title: 'Mkkellogg 测试 - Web Wide World' },
    props: true,
  },
];

const router = createCustomRouter(routes);

// 导出路由组件
export { default as RouterView } from './RouterView.vue';
export { default as RouterLink } from './RouterLink.vue';

export default router;


